import { DISCOUNT_EXCLUDED_PRODUCT_IDS } from "@/constants/product-collections";

export const isExcludedFromDiscount = (productId: number): boolean =>
  DISCOUNT_EXCLUDED_PRODUCT_IDS.has(productId);
